import { apiClient } from "@/lib/api";
import { fetchAllPages } from "@/lib/fetchAllPages";
import type { Host, HostCreate } from "@/types";

/** Backend cap: GET /hosts `limit` le=100. */
const HOSTS_PAGE_SIZE = 100;

export const hostService = {
  // Create a new host (ADMIN only)
  create: async (data: HostCreate): Promise<Host> => {
    const response = await apiClient.post<Host>("/hosts", data);
    return response.data;
  },

  // Get all hosts (ADMIN only)
  getAll: (): Promise<Host[]> =>
    fetchAllPages(async (page) => {
      const response = await apiClient.get<Host[]>("/hosts", { params: page });
      return response.data;
    }, HOSTS_PAGE_SIZE),
};
